/**
 * Gestione di `config.options.webhookSecret` nel DataSourceDialog.
 *
 * Il segreto HMAC del webhook ArcHives lo genera ArcHives: nel Builder va solo
 * il NOME della variabile d'ambiente del site-backend (`${NOME_VAR}`), mai il
 * valore. Il salvataggio fonde con le `options` esistenti (capabilitiesTtl,
 * layers, initialView, staticParams, …), senza sostituirle.
 */

import {
  ENV_PLACEHOLDER_REGEX,
  WEBHOOK_SECRET_PLACEHOLDER_MESSAGE,
} from "@onecreator/shared/validation";

type Options = Record<string, unknown>;

export function getWebhookSecret(options: Options | undefined): string {
  const value = options?.webhookSecret;
  return typeof value === "string" ? value : "";
}

/**
 * Ritorna le options con `webhookSecret` impostato (fusione) o rimosso (campo
 * vuoto). Non muta l'input. Se non resta nessuna option ritorna `undefined`.
 */
export function setWebhookSecret(
  options: Options | undefined,
  value: string,
): Options | undefined {
  const { webhookSecret: _removed, ...rest } = options ?? {};
  const trimmed = value.trim();
  const next: Options = trimmed ? { ...rest, webhookSecret: trimmed } : rest;
  return Object.keys(next).length > 0 ? next : undefined;
}

/** Messaggio d'errore per il campo, `null` se vuoto o placeholder valido. */
export function validateWebhookSecretInput(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed || ENV_PLACEHOLDER_REGEX.test(trimmed)) return null;
  return WEBHOOK_SECRET_PLACEHOLDER_MESSAGE;
}
